<template>
  <div class="home">
    <div class="content1">
      <div class="content-box">
        <div class="head" style="letter-spacing: 0.04rem;">
          {{nowData.title}}
        </div>
        <div class="line"></div>
        <div class="text" v-for="(item, index) in nowData.answer" :key="index" style="letter-spacing: 0.04rem;">
          <span v-html="item" @click="toTab"></span>
        </div>
        <video v-if="nowData.video" :src="nowData.video" class="videos" object-fit="contain" :poster="nowData.poster" controls></video>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  data() {
    return {
      id: '1',
      data: [
        {
          title: '刚来成都有什么可以了解?',
          answer: [
            '您可以通过<span style="color:#006CFF;text-decoration:underline;user-select: none;;" data-tagName="1">“创享成都”</span>和<span style="color:#006CFF;text-decoration:underline;user-select: none;;" data-tagName="2">“幸福蓉漂”</span>来了解成都。',
            '<span style="color:#006CFF;text-decoration:underline;user-select: none;;" data-tagName="1">“创享成都”</span>为人才准备了多样化的视频，以及包含成都生活服务，吃喝玩乐等公众账号，方便人才和相关人员通过不同类型的公众账号体验成都，并且账号可通过长按二维码进行关注，掌握实时信息。',
            '<span style="color:#006CFF;text-decoration:underline;user-select: none;;" data-tagName="2">“幸福蓉漂”</span>涵盖了更多人才相关的资讯以及区（市）县的人才公众号，区（市）县公众号也可通过长按二维码进行关注。'
          ],
          video: require('../assets/想要了解成都.mp4'),
          poster: require('../assets/想要了解成都.png')
        },
        {
          title: '成都有哪些人才政策?',
          answer: [
            '目前平台上线了19条成都市人才相关政策，包含3条重点专项，3条人才落户，5条人才安居，4条人才生活补贴，1条生活服务，2条青年人才创新创业，1条发展激励，以及23个区（市）县人才政策，人才可通过<span style="color:#006CFF;text-decoration:underline;user-select: none;;" data-tagName="7">“政策查询”</span>查询到相关政策详情，一图看懂。 ',
            '政策如有更新，我们也将第一时间在平台进行提示。'
          ],
          video: require('../assets/成都有哪些人才政策.mp4'),
          poster: require('../assets/成都有哪些人才政策.png')
        },
        {
          title: '我能享受哪些政策?',
          answer: [
            '您可以通过“政策匹配”功能的<span style="color:#006CFF;text-decoration:underline;user-select: none;;" data-tagName="3">“画像匹配”</span>和<span style="color:#006CFF;text-decoration:underline;user-select: none;;" data-tagName="4">“精准匹配”</span>得到相应的结果。',
            '<span style="color:#006CFF;text-decoration:underline;user-select: none;;" data-tagName="3">“画像匹配”</span>以输入个人信息为主，最少只需4个问题即可得到成都市19条人才政策中适合的结果，并可以查阅政策详情，或跳转到相关链接进行政策办理。',
            '<span style="color:#006CFF;text-decoration:underline;user-select: none;;" data-tagName="4">“精准匹配”</span>从落户政策、人才安居、安家补贴、人才创新创业、发展激励、人才绿卡6个纬度，为人才进行更精确的匹配，通过引导式问题的回答，得出具体享受到的政策结果，并可查看政策详情，或跳转到相关链接进行政策办理。'
          ],
          video: require('../assets/我能享受哪些政策.mp4'),
          poster: require('../assets/我能享受哪些政策.png')
        },
        {
          title: '我能购买人才公寓吗?',
          answer: [
            '选择“政策匹配”中的“精准匹配”-<span style="color:#006CFF;text-decoration:underline;user-select: none;;" data-tagName="5">“人才安居”</span>，根据个人情况进行问题回答，即可得到精准的政策结果。',
            ' 如可享受人才安居政策，还可选择<span style="color:#006CFF;text-decoration:underline;user-select: none;;" data-tagName="6">“人才公寓”</span>功能，挑选和查看适合的人才公寓。'
          ],
          video: require('../assets/我能购买人才公寓吗.mp4'),
          poster: require('../assets/我能购买人才公寓吗.png')
        },
        {
          title: '我能找到就业机会吗?',
          answer: [
            '选择“蓉漂人才荟”，这里为人才准备了各类行业的相关工作岗位，并进行更新，可选择感兴趣的职位通过联系方式进行简历投递。'
          ],
          // video: 'https://smart.cdtalents.cn:18888/media/video/20230327/xfrp.mp4'
        },
      ]
    }
  },
  created() { },
  mounted() {
    this.id = this.$route.query.id
    // console.log(this.nowData);
  },
  computed: {
    nowData() {
      return this.data[this.id - 1]
    }
  },
  methods: {
    toTab(e) {
      let tagName = e.target.dataset.tagname
      console.log(tagName);
     if(tagName){
      switch(tagName){
        case '1':
        wx.miniProgram.redirectTo({
          // url: `/pages/talentView/talentView?weburl=https://cdtalent.jianshankeji.com/talentPolicy/#/normal?id=1`
          url: `/pages/talentView/talentView?weburl=aaa`
         })
        break
        case '2':
        wx.miniProgram.redirectTo({
          // url: `/pages/index/newsList?weburl=https://cdtalent.jianshankeji.com/talentPolicy/#/normal?id=1`
          url: `/pages/index/newsList?weburl=aaa`
         })
        break
        case '3':
        wx.miniProgram.redirectTo({
          // url: `/pages/AImatch/match?weburl=https://cdtalent.jianshankeji.com/talentPolicy/#/normal?id=3`
          url: `/pages/AImatch/match?weburl=aaa`
         })
        break
        case '4':
        wx.miniProgram.redirectTo({
          // url: `/pages/AImatch/AImatch?weburl=https://cdtalent.jianshankeji.com/talentPolicy/#/normal?id=3`
          url: `/pages/AImatch/AImatch?weburl=aaa`
         })
        break
        case '5':
        wx.miniProgram.redirectTo({
          // url: `/pages/AImatch/matchSelect?id=2&weburl=https://cdtalent.jianshankeji.com/talentPolicy/#/normal?id=4`
          url: `/pages/AImatch/matchSelect?id=2&weburl=aaa`
         })
        break
        case '6':
        wx.miniProgram.redirectTo({
          // url: `/pages/AImatch/matchSelect?id=2&weburl=https://cdtalent.jianshankeji.com/talentPolicy/#/normal?id=4`
          url: `/pages/talentService/talentService?weburl=aaa`
         })
        break
        case '7':
        wx.miniProgram.redirectTo({
          // url: `/pages/policyChannel/policyQuery?weburl=https://cdtalent.jianshankeji.com/talentPolicy/#/normal?id=2`
          url: `/pages/policyChannel/policyQuery?weburl=aaa`
         })
        break
        default:
        wx.miniProgram.redirectTo({
          url: `/pages/policyChannel/policyQuery`
         })
          break
      }
     }
    },
  }
}
</script>

<style lang="scss" scoped>
.home {
  box-sizing: border-box;
  min-height: 100vh;
  color: #000;
  background-size: contain;
  background-repeat: no-repeat;
  padding: 0.32rem;
  width: 7.5rem;
  position: relative;
  margin: 0 auto;
  background-color: #f7f6f9;

  .content1 {
    .title {
      width: 1.57rem;
      height: 0.5rem;
      position: relative;
      font-size: 0.34rem;
      font-weight: bold;
      word-break: keep-all;
      color: #333333;

      .text-bg {
        position: absolute;
        width: 100%;
        height: 100%;
      }
    }

    .nav-item {
      font-size: 0.28rem;
      width: 100%;
      height: 0.5rem;
      font-weight: 500;
      color: #313E62;
      line-height: 42rpx;
      display: flex;
      align-items: center;
      justify-content: space-between;
      text-indent: 1em;
      position: relative;

      &::before {
        content: '';
        position: absolute;
        left: 0;
        width: 0.09rem;
        height: 0.09rem;
        border-radius: 50%;
        background-color: #0F75FF;
      }
    }

    .content-box {
      margin-top: 0.24rem;
      margin-bottom: 0.24rem;
      width: 6.86rem;
      background-color: #fff;
      padding: 0.18rem;
      box-sizing: border-box;
      border-radius: 0.1rem;
      text-align: left;

      .head {
        font-size: .32rem;
        font-weight: bold;
        color: #333333;
        display: flex;
        align-items: center;

        .icon {
          width: .44rem;
          height: .44rem;
          margin-right: .10 rem;
        }
      }

      .line {
        width: 100%;
        height: 0.02rem;
        background-color: #BCCAF1;
        margin-top: 0.20rem;
        margin-bottom: 0.20rem;
        opacity: 0.5;
      }

      .text {
        font-size: .28rem;
        color: #313E62;
        line-height: .42rem;
        font-weight: 500;

      }

      .videos {
        margin-top: 0.5rem;
        width: 100%;
      }
    }
  }
}</style>